// IDI contact options actions
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import axios from 'axios';
import Page from '../../lib/page';
import { IDIChannelFilter, isAsyncChatEnable, getWaitTime } from '../../lib/asyncMessageHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import * as types from '../constants/ActionTypes';
import updateLexaMessage from './action-lexa-message';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const emailByPassPage = 'emailByPassPage';

function requestIDIContactOptions() {
  return {
    type: types.REQUEST_IDI_CONTACT_OPTIONS,
  };
}

function receivedIDIContactOptionsError() {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR,
  };
}

// Passing IDI channels(contact options) to redux state
function receivedIDIContactOptions(payload) {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE,
    payload,
  };
}

function receivedResponseFromRisk(riskOptions) {
  return {
    type: types.RECEIVED_RESPONSE_FROM_RISK,
    payload: riskOptions,
  };
}

function requestResponseFromIdi() {
  return {
    type: types.REQUEST_RESPONSE_FROM_RISK,
  };
}

export const displayVhtWidget = () => ({
  type: types.DISPLAY_VHT_WIDGET,
});

export const hideVhtWidget = () => ({
  type: types.HIDE_VHT_WIDGET,
});
// Send IDI Post request to IDI server
export function userSelectionPostRequest(kanaCode, topicName) {
  return axios.post('/smarthelp/update-user-selection', {
    _csrf: Page.getCSRFtoken(),
    topicId: kanaCode,
    topicName,
  });
}

// This function is used to to fetch for contact options
export function getIdiContactChannels(kanaCode, topicName) {
  return (dispatch) => {
    dispatch(requestResponseFromIdi());
    const postRequest = userSelectionPostRequest(kanaCode, topicName);
    postRequest.then((response) => {
      dispatch(receivedResponseFromRisk((response.data || {}).channel_availability_decisions || {}));
    });
    postRequest.catch(() => dispatch(receivedIDIContactOptionsError()));
  };
}

// Update User Selection for both Login and Logout users
export function updateUserSelection(id, topicname = '') {
  return (dispatch, getState) => {
    // if topic name is empty in the state, take the topic name passed to this function
    // Topic name is empty in the state on email page, while calling idi for PAYPUI001 T-code
    const topicName = _get(getState(), 'selectResult.topicTreeSelectResult.topicName', '') || topicname;
    const kanaCode =
      id === emailByPassPage ? _get(getState(), 'emailNoIntent.kanaCode') : _get(getState(), 'emailForm.kanaCode', '');
    // if user directly visit webform page, don't execute the fpti
    if (id !== emailByPassPage) {
      trackLink({ id, link: `smarthelp-topic-update-idi|${kanaCode}|` });
    }

    dispatch(requestResponseFromIdi());
    return axios
      .post('/smarthelp/update-user-selection', {
        _csrf: Page.getCSRFtoken(),
        topicId: kanaCode,
        topicName,
      })
      .then((response) => {
        if (Page.getIsIDIContactOptions()) {
          dispatch(requestIDIContactOptions());
          dispatch(receivedResponseFromRisk((response.data || {}).channel_availability_decisions || {}));
          let IDIChannels = IDIChannelFilter(_get(response, 'data.channels'));
          const availability = _get(response, 'data.channel_availability_decisions', []);
          // Checking the Message option whether exists in the IDI response or not
          if (isAsyncChatEnable({ channels: IDIChannels, availability })) {
            const waitTime = getWaitTime(availability); // get Message_Us estimate wait time
            dispatch(updateLexaMessage({ available: true, waitTime }));
          } else if (Array.isArray(IDIChannels)) {
            // If async message is not available, then filter out async option
            IDIChannels = IDIChannels.filter((channel) => channel.type !== 'message');
            dispatch(updateLexaMessage({ available: false }));
          }
          if (Array.isArray(IDIChannels) && IDIChannels.length > 0) {
            if (Page.hasChatOptions(IDIChannels)) {
              trackPage({ id: 'contactUsPage', link: 'chat-option-lexa' });
            }
            dispatch(receivedIDIContactOptions({ channels: IDIChannels, availability }));
          } else {
            dispatch(receivedIDIContactOptionsError());
          }
        }
        // For NON IDI and Logged out case store the response in state to check if chat is available in IDI response
        // to show logged out chat link in email login modal window.
        // IF not logged in and has IDI response store the response in store.
        if (!Page.isLoggedIn() && !_isEmpty(response.data.channel_availability_decisions)) {
          dispatch(receivedResponseFromRisk((response.data || {}).channel_availability_decisions || {}));
        }
      })
      .catch(() => {
        dispatch(receivedIDIContactOptionsError());
      });
  };
}

export const exportedForTesting = {
  requestIDIContactOptions,
  receivedIDIContactOptionsError,
  receivedIDIContactOptions,
  receivedResponseFromRisk,
  requestResponseFromIdi,
};
